import React from "react";
import "./loader.css"; // Import external CSS for styles

const LoadingAnimation: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-gray-200">
      <div className="flex gap-5">
        {/* Wave Loader */}
        <div className="flex gap-2">
          {[...Array(5)].map((_, i) => (
            <span key={i} className={`wave-loader wave-${i + 1}`}></span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingAnimation;